module.exports = __webpack_public_path__ + "img/puzzle1-400.d611a67a.png";